<template>
  <div>
    <el-dialog :show-close=false :visible.sync="centerDialogVisible" top="25vh"  width="30%"  center :close-on-click-modal=false :close-on-press-escape=false >
      <div class="txt">亲爱的老师，请选择您的任教科目</div>
      <div class="subject">
        <el-radio v-model="subject" label="0" border>英语</el-radio>
        <el-radio v-model="subject" label="2" border disabled>语文（暂未开放）</el-radio>
        <el-radio v-model="subject" label="1" border disabled>数学（暂未开放）</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="sure-bind" type="primary" @click="bindSubject()" >立即使用</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from '../utils/api.js'
export default {
  name: 'BindSubjectDialog',
  data () {
    return {
      centerDialogVisible: false,
      subject: '0'
    }
  },
  methods: {
    showDialog () {
      this.centerDialogVisible = true
    },
    bindSubject () {
      const _this = this
      let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      userInfo.subjectName = '英语'
      api.post('ChooseTeacherCourseRequest', {
        moduleType: parseInt(_this.subject)
      }, () => {
        userInfo.moduleType = _this.subject
        window.sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
        _this.centerDialogVisible = false
        _this.afterBindSubject()
        _this.$store.dispatch('setUsrinfo', userInfo)
      })
    },
    afterBindSubject () {
      let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      this.$emit('onSetSubjext', userInfo)
    }
  }
}
</script>
<style scoped>
.txt{
  text-align: center;
  padding-bottom: 20px;
}
.subject{
  text-align: center;
}
.sure-bind{
  width: 300px;
}
</style>
